import { useQuery } from 'react-query';
import { jiraStatusApi } from '../../api';

export function useCheckJiraStatus() {
  const query = useQuery(['jira_status'], () => jiraStatusApi());
  return query;
}
